import type { PropsWithChildren } from 'react';
import { createContext, useContext } from 'react';
import { locationCardDefaultProps } from '../common/location-card-default-props';
import type { LocationCardProps } from '../common/location-card-types';

const LocationCardPropsContext = createContext<LocationCardProps>(
  locationCardDefaultProps
);

export function LocationCardPropsProvider({
  children,
  ...settings
}: PropsWithChildren<Partial<LocationCardProps>>) {
  return (
    <LocationCardPropsContext.Provider
      value={{ ...locationCardDefaultProps, ...settings }}
    >
      {children}
    </LocationCardPropsContext.Provider>
  );
}

export const useLocationCardProps = () => {
  return useContext(LocationCardPropsContext);
};
